export enum AmountType { None = 0, Amount, Percentage }

export enum PaymentType { ACH = 1, Card }

export enum ProductType { SunboundPay = 1, Gateway }

export enum FeeType { Fixed = 1, Percentage }

export enum TransactionStatus { pending = 1, succeeded, declined, rejected }

export enum Preference { emails = 1, selectedAccount }
